import React from 'react';
import {useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {StyleSheet} from 'aphrodite';

import LandingPagePage from '../';

export const LandingPageStyleWrapperPage = () => {

  const settings = useSelector((state) => state.settings.get('settings').toJS());

  const styleKeys = [
    'header', 'headerLogo', 'headerLink', 'headerPageLink',
    'footer', 'footerLogo', 'footerRows', 'footerLink',
    'landingPage', 'introductionSection', 'initialInstructionSection',
    'dropdown', 'dropdownSelectorButton', 'dropdownSelectorMenu',
    'postMainContent',
    'loginBackground', 'loginButton', 'headerUsageDisclaimer'
  ];

  const styleSheetObject = {
    ...Object.fromEntries(
      styleKeys.map((key) => [key, settings.styles?.[key] || {}])
    )
  };

  //TODO: incorporate footelements into above with ... operator.
  let footerElementIndex = 0;
  settings.styles.footerLayout.forEach((rowArray) => {
    rowArray.forEach((column) => {
      styleSheetObject[`footerElement${footerElementIndex++}`] = column.style;
    });
  });

  const styleSheet = StyleSheet.create(styleSheetObject);
  return (<LandingPagePage settings={settings} styleSheet={styleSheet}/>);
};

export default withRouter(LandingPageStyleWrapperPage);
